<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box">
        <el-row type="flex" align="middle">
          <el-button v-acl="RMC_PROT_3P_SUBMIT" v-if="statusView=='S'" size="mini" type="primary" @click="submitData('detailInfo')">提交</el-button>
        </el-row>
      </div>

      <div class="handle-box">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">ASL审核</p>
        </div>
        <el-form :model="detailInfo" ref="detailInfo" :rules="rules" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="年份" prop="year">
                <el-date-picker v-model="detailInfo.year" @change="yearChange" :disabled="statusView=='S'?false:true" style="width:100%" value-format="yyyy" type="year" placeholder="选择年"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Protein ASL" prop="rmcProteinAslId">
                <el-select v-model="detailInfo.rmcProteinAslId" :disabled="statusView=='S'&&!$route.query.id?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in aslGroupCodeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sponsor">
                <el-input v-model="detailInfo.sponsorName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="审核类型" prop="auditType">
                <ic-select :disabled="$route.query.id?true:false" table="TT_RMC_PROTEIN_AUDIT_REPORT" @change="getType" filterable field="AUDIT_TYPE" clearable v-model="detailInfo.auditType" style="width:100%"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="Category3" prop="category3Code">
                <el-select v-model="detailInfo.category3Code" @change="getCategory3Name" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="GMP" prop="gmp" :rules="{required:isGmpMust,message:'请选择GMP',trigger: 'change'}">
                <el-select v-model="detailInfo.gmp" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in gradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="HACCP" prop="haccp" :rules="{required:isMust,message:'请选择HACCP',trigger: 'change'}">
                <el-select v-model="detailInfo.haccp" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in gradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Antibiotics" prop="antibiotics" :rules="{required:isMust&&detailInfo.category3Code!='10103'?true:false,message:'请选择Antibiotics',trigger: 'change'}">
                <el-select v-model="detailInfo.antibiotics" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in gradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="AnimalWalfare" prop="animalWalfare" :rules="{required:isMust,message:'请选择AnimalWalfare',trigger: 'change'}">
                <el-select v-model="detailInfo.animalWalfare" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in gradeList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="ASL审核时间" prop="aslAuditDate" :rules="{required:detailInfo.auditType=='SECOND_PARTY_VERIFY_REPORT'?true:isMust?true:false,message:'请选择ASL审核时间',trigger: 'change'}">
                <el-date-picker :disabled="statusView=='S'?false:true" v-model="detailInfo.aslAuditDate" style="width:100%;" @change="changeDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="`${customLabel}`" prop="swa" :rules="{required:isMust1,message:'请选择'+customLabel,trigger: 'change'}">
                <el-select v-model="detailInfo.swa" :disabled="statusView=='S'?false:true" clearable style="width:100%" placeholder="请选择">
                  <el-option :key="index" v-for="(item,index) in swaList" :label="item.name" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="`${customLabel}审核时间`" prop="swaAuditDate">
                <el-date-picker :disabled="statusView=='S'?false:true" style="width:100%" @change="changeSwaDate" v-model="detailInfo.swaAuditDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :disabled="statusView=='S'?false:true" maxlength="1000" show-word-limit v-model="detailInfo.remark" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="handle-box" style="margin-top:20px;">
        <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
          <p class="line"></p>
          <p class="info_title">附件</p>
        </div>
        <el-row type="flex" style="margin-top:10px;" align="middle">
          <el-col :span="12" style="height:100%;display: flex;align-items: center;">
            <el-button v-acl="RMC_PROT_3P_UPLOAD" size="small" type="primary" @click="openFile" :disabled="detailInfo.auditType?false:true">
              {{$t('common.selectFile')}}
            </el-button>
          </el-col>
        </el-row>
        <el-table ref="plxTable" :data="fileList" style="margin-top:10px;" max-height="500" show-overflow="ellipsis" highlight-current-row>
          <el-table-column label="附件类型" align="center" prop="userName">
            <template slot-scope="scope">
              <span>{{scope.row.isType}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="文件名称" prop="documentName">
            <template slot-scope="scope">
              <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label="文件描述" align="center" prop="docComments">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.isDescribe" placement="top-start">
                <span>{{scope.row.isDescribe}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="上传人" align="center" prop="userName"></el-table-column>
          <el-table-column label="上传时间" align="center" prop="createDate"></el-table-column>
          <el-table-column label="操作" align="center" prop="updateDate" v-if="statusView=='S'">
            <template v-slot="scope">
              <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row,scope.$index)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <uploadFile v-if="dialogVisible" @close="handleClose" :detailInfo="detailInfo" :tsReckindId="tsReckindId"></uploadFile>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import proteinDrug from "@/api/rmcProtein/drug";
import commonFunction from "@/utils/dataTableUtils";
import prot3p from '@/api/rmcProtein/prot3p'
import rules from './rules'
import QBRApi from "@/api/QBR/index";
import uploadFile from './dialog/uploadFile'
import { fileService } from "@/api/common/file-utils"
import qspiReport from "@/api/qspiReport/index";

export default {
  name: '',
  components: {
    IcSelect,
    uploadFile
    // detailDialog
  },
  data() {
    return {
      isGmpMust: false,
      isMust: false,
      fileList: [],
      aslGroupCodeList: [],
      swaList: [],
      gradeList: [],
      dialogVisible: false,
      identity: localStorage.getItem('ms_emplFlag'),
      allDate: [],
      multipleSelection: [],
      categoryList2: [],
      categoryList3: [],
      statusList: [],
      detailInfo: {
        attachment: {}
      },
      category3List: [],
      isShow: false,
      showDetailDialog: false,
      formData: null,
      totalCount: "",
      statusView: "",
      rules: rules,
      isMust1: false,
      customLabel: ""
    }
  },
  created() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    if (this.identity == 'SUP') {   //判断是供应商
      this.statusView = 'S';
    } else {
      if (ms_roles.indexOf("QSPI_RMC_PROTEIN_CQS") != -1) {
        this.statusView = 'C'
      }
    }
    this.getTableLable()
    this.getdCategory3()
    this.getSelector()
    this.getSelectorForAsl()
    this.getSponsorByUser()
    if (this.$route.query.id) {
      this.getDetail()
    }
  },
  methods: {
    getTableLable() {
      var year = this.detailInfo.year ? this.detailInfo.year : '9999'
      qspiReport.getQspiMonthlyTbleLabel('SWA', year).then(res => {
        console.log("GY🚀 ~ qspiReport.getQspiMonthlyTbleLabel ~ res:", res);
        this.customLabel = res
      });
    },
    yearChange(val) {
      this.getTableLable()
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'protein'
        })
        if (this.category3List.length == 1) {
          this.$set(this.detailInfo, 'category3Code', this.category3List[0].key)
          this.$set(this.detailInfo, 'category3Name', this.category3List[0].object)
          this.$refs['detailInfo'].clearValidate(['category3Code']);
        }
      })
    },
    getSponsorByUser() {
      proteinDrug.getSponsorByUser().then((res) => {
        this.$set(this.detailInfo, "sponsorCode", res.data.supplierCode)
        this.$set(this.detailInfo, "sponsorName", res.data.supplierName)
      })
    },
    getSelectorForAsl() {
      prot3p.getSelectorForAsl().then((res) => {
        if (res.code == 200) {
          res.data.forEach((v) => {
            let obj = {}
            obj.name = v.aslName
            obj.code = v.rmcProteinAslId
            this.aslGroupCodeList.push(obj)
          })
          var codeLists = res.data.map(ele => {
            return ele.rmcProteinAslId
          })

          if (!codeLists.includes(this.detailInfo.rmcProteinAslId) && this.$route.query.id) {
            this.aslGroupCodeList.push({
              code: this.detailInfo.rmcProteinAslId,
              name: this.detailInfo.aslName,
            })
          }
          console.log("查询列表====", this.aslGroupCodeList)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getDetail() {
      prot3p.queryDeatil(this.$route.query.id).then((res) => {
        if (res.data.auditType == 'SECOND_PARTY_VERIFY_REPORT') {
          this.isMust = false
          this.isGmpMust = true
        } else {
          // this.isMust=true
          if (res.data.aslAuditDate) {
            this.isMust = true
            this.isGmpMust = true
          } else {
            this.isMust = false
            this.isGmpMust = false
          }
        }
        this.detailInfo = res.data
        this.getFileLists()
      })
    },
    changeDate(val) {
      if (val && this.detailInfo.auditType == 'TRIPARTITE_PARTY_VERIFY_REPORT') {
        this.isMust = true
        if (this.detailInfo.aslAuditDate) {
          this.isGmpMust = true
        } else {
          this.isGmpMust = false
        }
      } else {
        this.isMust = false
        if (this.detailInfo.aslAuditDate) {
          this.isGmpMust = true
        } else {
          this.isGmpMust = false
        }
      }
    },
    changeSwaDate(val) {
      if (val && this.detailInfo.auditType == 'TRIPARTITE_PARTY_VERIFY_REPORT') {
        this.isMust1 = true
      } else {
        this.isMust1 = false
      }
    },
    getType(val) {
      if (val == 'SECOND_PARTY_VERIFY_REPORT') {  //2方报告
        this.isMust = false
        this.isGmpMust = true
        this.isMust1 = false
      } else {
        if (this.detailInfo.aslAuditDate) {
          this.isMust = true
          this.isGmpMust = true
        } else {
          this.isMust = false
          this.isGmpMust = false
        }
        if (this.detailInfo.swaAuditDate) {
          this.isMust1 = true
        } else {
          this.isMust1 = false
        }
      }
      this.fileList = []
      console.log('vlavlavla===', val)
    },
    getFileLists() {
      QBRApi.getFileLists({
        tsReckindId: this.detailInfo.auditType == 'TRIPARTITE_PARTY_VERIFY_REPORT' ? "TRIPARTITY_PARTY_UPLOAD" : "SECOND_PARTY_UPLOAD",
        tsRecId: this.detailInfo.ttRmcProteinAuditReportId
      }).then(res => {
        res.forEach((v) => {
          if (!v.isType) {
            v.isType = v.docComments.split('-')[v.docComments.split('-').length - 1]
          }
          if (!v.isDescribe) {
            let newIndex = v.docComments.lastIndexOf('-')
            v.isDescribe = v.docComments.split('-' + v.docComments.substring(newIndex + 1, v.docComments.length))[0]
            // v.isDescribe=v.docComments.split('@#$')[0]
          }
        })
        this.fileList = res
      });
    },
    getSelector() {
      prot3p.getSelector().then((res) => {
        res.data.grade.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.gradeList.push(obj)
        })
        res.data.swa.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.swaList.push(obj)
        })
      })
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    onDownload(val) {
      fileService.downloadFile(val).then((res) => { })
    },
    handleClose(val, data) {
      console.log("🚀 ~ file: detail.vue:369 ~ handleClose ~ data", data)
      console.log("🚀 ~ file: detail.vue:369 ~ handleClose ~ val", val)
      this.dialogVisible = false
      if (val && data.length > 0) {
        let str = val.docComments
        let newIndex = str.lastIndexOf('-')
        data[0].docComments = val.docComments
        data[0].isType = str.substring(newIndex + 1, str.length)
        data[0].isDescribe = str.split('-' + str.substring(newIndex + 1, str.length))[0]
        console.log("🚀 ~ file: detail.vue:378 ~ handleClose ~ data", data)
        console.log('this.fileList', this.fileList);
        if (this.fileList.length > 0) {
          this.fileList.forEach((v) => {
            if (!v.isType) {
              v.isType = v.docComments.split('-')[v.docComments.split('-').length - 1]
            }
            if (!v.isDescribe) {
              let newIndex = v.docComments.lastIndexOf('-')
              v.isDescribe = v.docComments.split('-' + v.docComments.substring(newIndex + 1, v.docComments.length))[0]
            }
          })
          // let isIndex = this.fileList.findIndex((v) => { return v.docComments.split('-')[v.docComments.split('-').length - 1] == val.docComments.split('-')[v.docComments.split('-').length - 1] })
          // if (isIndex != -1) {
          //   this.fileList.splice(isIndex, 1, data[0])
          // } else {
          this.fileList = this.fileList.concat(data)
          // }
          console.log("获取的列表========", this.fileList)
        } else {
          this.fileList = this.fileList.concat(data)
        }
        this.detailInfo.attachment.tsReckindId = this.detailInfo.auditType == 'TRIPARTITE_PARTY_VERIFY_REPORT' ? "TRIPARTITY_PARTY_UPLOAD" : "SECOND_PARTY_UPLOAD"
        this.detailInfo.attachment.tsRecId = this.detailInfo.ttRmcProteinAuditReportId ? this.detailInfo.ttRmcProteinAuditReportId : null
        this.detailInfo.attachment.documents = this.fileList
        // this.fileList.push(obj)
      }
      // this.getFileLists()
    },
    delFile(file, index) {
      if (file.tmDocumentId) {
        fileService.deleteFile(file.tmDocumentId).then((res) => {
          if (res.code === '200') {
            this.fileList.splice(index, 1);
            this.getFileLists()
          }
        })
      } else {
        this.fileList.splice(index, 1);
      }
    },
    openFile() {
      this.dialogVisible = true
      // if(this.$route.query.id){
      //   this.dialogVisible=true
      // }else{
      //   prot3p.submitAuditReport(this.detailInfo).then((res)=>{
      //     if(res.code==200){
      //       this.detailInfo=res.data
      //       this.dialogVisible=true
      //     }else{
      //       this.$message.error(res.msg)
      //     }
      // })
      // }

    },
    submitData(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          let arr = []
          if (this.detailInfo.auditType == 'SECOND_PARTY_VERIFY_REPORT') {    //2
            if (this.detailInfo.aslAuditDate) {
              console.log("2方审核报告===")
            } else {
              return this.$message.error('请维护ASL审核时间，谢谢')
            }
            this.fileList.forEach((v) => {
              arr.push(v.docComments.split('-')[v.docComments.split('-').length - 1])
            })
            if (arr.indexOf('GMP') != -1 && arr.indexOf('ASL整改') != -1) {
              if (this.fileList.length > 0) {
                prot3p.submitAuditReport(this.detailInfo).then((res) => {
                  if (res.code == 200) {
                    this.$message.success("提交成功")
                    this.routerBack()
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
              }
            } else {
              this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
            }


          } else if (this.detailInfo.auditType == 'TRIPARTITE_PARTY_VERIFY_REPORT') {   //3

            if (this.detailInfo.aslAuditDate || this.detailInfo.swaAuditDate) {
            } else {
              return this.$message.error('至少维护一个审核时间：ASL审核时间或者' + this.customLabel + '审核时间，谢谢')
            }
            this.fileList.forEach((v) => {
              arr.push(v.docComments.split('-')[v.docComments.split('-').length - 1])
            })
            if (this.detailInfo.category3Code == 10101) {     //poultry
              if (this.detailInfo.swaAuditDate) {
                if (arr.indexOf('SCHR') != -1 && arr.indexOf('SCHR整改') != -1) {
                } else {
                  return this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
                }
              }
              if (this.detailInfo.aslAuditDate) {
                if (arr.indexOf('GMP') != -1 && arr.indexOf('HACCP') != -1 && arr.indexOf('Antibiotics') != -1 && arr.indexOf('Animal Walfare') != -1 && arr.indexOf('ASL整改') != -1) {

                } else {
                  return this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
                }
              }
              if (this.fileList.length > 0) {
                prot3p.submitAuditReport(this.detailInfo).then((res) => {
                  if (res.code == 200) {
                    this.$message.success("提交成功")
                    this.routerBack()
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
              }
              // }else{
              //   this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
              // }
            } else {
              // if( this.detailInfo.aslAuditDate&& arr.indexOf('GMP')!=-1&&arr.indexOf('HACCP')!=-1&&arr.indexOf('Animal Walfare')!=-1&&arr.indexOf('ASL整改')!=-1 ||this.detailInfo.swaAuditDate &&arr.indexOf('SWA')!=-1&& arr.indexOf('SWA整改')!=-1 ){
              if (this.detailInfo.swaAuditDate) {
                if (arr.indexOf('SCHR') != -1 && arr.indexOf('SCHR整改') != -1) {
                } else {
                  return this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
                }
              }
              if (this.detailInfo.aslAuditDate) {
                if (arr.indexOf('GMP') != -1 && arr.indexOf('HACCP') != -1 && arr.indexOf('Animal Walfare') != -1 && arr.indexOf('ASL整改') != -1) {

                } else {
                  return this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
                }
              }
              if (this.fileList.length > 0) {
                prot3p.submitAuditReport(this.detailInfo).then((res) => {
                  if (res.code == 200) {
                    this.$message.success("提交成功")
                    this.routerBack()
                  } else {
                    this.$message.error(res.msg)
                  }
                })
              } else {
                this.$message.error('请将所有带*必传附件上传后再提交，谢谢')
              }
            }
          }

        } else {
          return false;
        }
      });

    },
    getCategory3Name(val) {
      let getName = this.category3List.filter((v) => {
        return v.key == val
      })
      this.detailInfo.category3Name = getName[0].object
    },
    routerBack() {
      this.$router.back();
    }

  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm .el-col {
  margin-top: 10px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
